import Vue from "vue";
import Router from "vue-router";

import store from "../store";
import { webAuth } from "../../src/auth/index.js";

Vue.use(Router);

function transformCarfaxCallback(to, from, next) {
  if (location.hash == "#/carFaxCallback") {
    location.replace(location.pathname + location.hash + location.search);
  }
  next();
}

function onChange(to, from, next) {
  // Set IsEmbedded
  let isEmbedded =
    location.hash.startsWith("#/mobile") ||
    location.hash.startsWith("#/embedded");
  store.dispatch("toggleEmbeddedMode", isEmbedded);
  store.dispatch("toggleMobileMode", location.hash.startsWith("#/mobile"));

  document.title = to.meta && to.meta.title ? to.meta.title : "CXM";

  if (isEmbedded && store.getters.AccessToken) {
    next();
  } else {
    let hasToken = false;
    if (isEmbedded) {
      if (to.query.ssoToken) {
        store.dispatch("updateOAuthUser", {
          access_token: to.query.ssoToken
        });
        hasToken = true;
        next();
      }
    }

    if (!hasToken) {
      webAuth.getOAuthUser().then(() => {
        next();
      });
    }
  }
}

const router = new Router({
  routes: [
    // {
    //   path: "/mobile*",
    //   name: "Mobile",
    //   component: () => import("@/views/Mobile/Mobile.vue"),
    //   children: [
    //     {
    //       name: "VinScanner",
    //       component: () => import("@/components/mobile/VinScanner"),
    //       path: "/mobile/vinscanner",
    //       meta: { title: "Vin Scanner" }
    //     }
    //   ]
    // },
    {
      path: "/carfax/:dealerId/:vin",
      name: "CarFaxAuthorize",
      component: () => import("@/components/crm/Garage/CarFaxAuthorize.vue"),
      props: true
    },
    {
      path: "/carFaxCallback",
      name: "CarFaxCallback",
      component: () => import("@/components/crm/Garage/CarfaxCallback.vue"),
      props: route => ({ code: route.query.code, state: route.query.state })
    },
    {
      path: "/embedded*",
      name: "Embedded",
      component: () => import("@/views/Embedded/Embedded.vue"),
      children: [
        {
          name: "EmbeddedDealsheet",
          component: () =>
            import("@/components/embedded/EmbeddedDealsheetContainer"),
          path: "/embedded/dealsheet*",
          meta: { title: "DealSheet" }
        },
        {
          name: "EmbeddedCustomerDashboard",
          component: () =>
            import("@/components/embedded/EmbeddedCustomerDashboardContainer"),
          path: "/embedded/customerdashboard*",
          meta: { title: "Customer Profile" }
        },
        {
          name: "EmbeddedCustomerText",
          component: () => import("@/components/embedded/EmbeddedCustomerText"),
          path: "/embedded/customersms",
          meta: { title: "Customer SMS" }
        },
        {
          name: "EmbeddedCustomerEmail",
          component: () =>
            import("@/components/embedded/EmbeddedCustomerEmail"),
          path: "/embedded/customeremail",
          meta: { title: "Customer Email" }
        },
        {
          name: "EmbeddedCustomerLogCall",
          component: () =>
            import("@/components/embedded/EmbeddedCustomerLogCall"),
          path: "/embedded/customerlogcall",
          meta: { title: "Customer Log Call" }
        },
        {
          name: "EmbeddedCustomerLogNote",
          component: () =>
            import("@/components/embedded/EmbeddedCustomerLogNote"),
          path: "/embedded/customerlognote",
          meta: { title: "Customer Log Note" }
        },
        {
          name: "EmbeddedCustomerAppointment",
          component: () =>
            import("@/components/embedded/EmbeddedCustomerAppointment"),
          path: "/embedded/customerappointment",
          meta: { title: "Customer Appointment" }
        },
        {
          name: "EmbeddedCustomerMerge",
          component: () =>
            import("@/components/embedded/EmbeddedCustomerMerge"),
          path: "/embedded/customermerge",
          meta: { title: "Customer Merge" }
        },
        {
          name: "EmbeddedDmsPush",
          component: () => import("@/components/embedded/EmbeddedDmsPush"),
          path: "/embedded/dmspush",
          meta: { title: "Push To DMS" }
        },
        {
          name: "EmbeddedPrintForms",
          component: () => import("@/components/embedded/EmbeddedPrintForms"),
          path: "/embedded/printforms",
          meta: { title: "Print Forms" }
        },
        {
          name: "VehicleHistoryReport",
          component: () =>
            import("@/components/crm/Garage/VehicleHistoryReport"),
          path: "/embedded/vehiclehistoryreport",
          meta: { title: "Vehicle History Report" }
        }
      ]
    },
    {
      path: "/app",
      component: () => import("@/views/Web/Web.vue"),
      children: [
        {
          name: "managerDashboard",
          path: "managerdashboard",
          component: () => import("@/components/dashboards/Dashboard.vue"),
          meta: { title: "Manager Dashboard" }
        },
        {
          name: "bdcDashboard",
          path: "bdcdashboard",
          component: () => import("@/components/dashboards/Dashboard.vue"),
          meta: { title: "BDC Dashboard" }
        },
        {
          name: "salesDashboard",
          path: "salesdashboard",
          component: () => import("@/components/dashboards/Dashboard.vue"),
          meta: { title: "Sales Dashboard" }
        },
        {
          name: "rulesAdministration",
          path: "workflowmanager",
          component: () => import("@/components/Rules/RulesContainer.vue"),
          meta: { title: "Workflow Manager" }
        },
        {
          name: "contactsearch",
          path: "contactsearch",
          component: () => import("@/components/crm/CrmSearch.vue"),
          meta: { title: "Customer Search" }
        },
        {
          name: "showroomdashboard",
          path: "showroomdashboard",
          component: () =>
            import("@/components/showroomdashboard/ShowroomDashboard.vue"),
          meta: { title: "Showroom Log" }
        },
        {
          name: "deliverydashboard",
          path: "deliverydashboard",
          component: () =>
            import("@/components/deliverydashboard/DeliveryDashboard.vue"),
          meta: { title: "Delivery Log" }
        },
        {
          name: "leadsdashboard",
          path: "leadsdashboard",
          component: () =>
            import("@/components/leadsdashboard/LeadsDashboard.vue"),
          meta: { title: "Leads Log" }
        },
        {
          name: "wishlist",
          path: "wishlist",
          component: () => import("@/components/wishlist/WishlistManager.vue"),
          meta: { title: "Wishlist Manager" }
        },
        {
          name: "inventory",
          path: "inventory",
          component: () => import("@/components/inventory/Inventory.vue"),
          meta: { title: "Inventory Beta" }
        },
        {
          name: "findbuyer",
          path: "findbuyer",
          component: () => import("@/components/inventory/FindBuyer.vue"),
          meta: { title: "Find a Buyer" }
        },
        {
          name: "calltrackingdashboard",
          path: "calltrackingdashboard",
          component: () =>
            import(
              "@/components/calltrackingdashboard/CallTrackingDashboard.vue"
            ),
          meta: { title: "Call Log" }
        },
        {
          name: "priorityopportunities",
          path: "priorityopportunities",
          component: () =>
            import(
              "@/components/opportunitiesdashboards/PriorityOpportunitiesDashboard.vue"
            ),
          meta: { title: "Priority Opportunities" }
        },
        {
          name: "operatorspanel",
          path: "operatorspanel",
          component: () => import("@/components/SLM/OperatorsPanel.vue"),
          meta: { title: "Operators Panel" }
        },
        {
          name: "slmdashboard",
          path: "slmdashboard",
          component: () => import("@/components/SLM/SLMDashboard.vue"),
          meta: { title: "SLM" }
        },
        {
          name: "opportunitiesdashboard",
          path: "opportunitiesdashboard",
          component: () =>
            import(
              "@/components/opportunitiesdashboards/OpportunitiesDashboard.vue"
            ),
          meta: { title: "Opportunities" }
        },
        {
          name: "opportunitiessearch",
          path: "opportunitiessearch",
          component: () =>
            import("@/components/opportunitiessearch/OpportunitiesSearch.vue"),
          meta: { title: "Opportunities Search" }
        },
        {
          name: "serviceexperience",
          path: "serviceexperience",
          component: () =>
            import(
              "@/components/serviceexperiencedashboard/ServiceExperienceDashboard.vue"
            ),
          meta: { title: "Service Experience" }
        },
        {
          name: "unmatcheddmssales",
          path: "unmatcheddmssales",
          component: () => import("@/components/web/UnmatchedDMSSales.vue"),
          meta: { title: "Unmatched Sales" }
        },
        {
          name: "reports",
          path: "reports",
          component: () => import("@/components/reports/TableauDashboard.vue"),
          meta: { title: "Reports" }
        },
        // ********** BEGIN PRIVATE PAGE(S) ROUTE **********
        {
          name: "privateHome",
          path: "private/bd1fc829-ba4f-4b44-b5e0-42040d6fc66f",
          component: () => import("@/components/privatepages/PrivateHome.vue"),
          meta: { title: "Activity Management" }
        },
        {
          name: "activityGroupsManagement",
          path: "private/activitygroupsmanagement",
          component: () =>
            import("@/components/privatepages/ActivityGroupsManagement.vue"),
          meta: { title: "Activity Groups Management" }
        },
        {
          name: "ruleGroupsManagement",
          path: "productconfig/rulegroupsmanagement",
          component: () =>
            import("@/components/productconfig/RuleGroupsManagement.vue"),
          meta: { title: "Rule Groups Management" }
        },
        // ********** END PRIVATE PAGE(S) ROUTE **********
        {
          name: "default",
          path: "default",
          component: () => import("@/components/Default.vue")
        },
        {
          path: "*",
          redirect: "default"
        },
        {
          path: "",
          redirect: "default"
        }
      ]
    },
    {
      path: "*",
      redirect: "app"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name == "CarFaxCallback") transformCarfaxCallback(to, from, next);
  else onChange(to, from, next);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js